import type { TFunction } from 'i18next';

import type { DashboardPanelSpec } from '@/features/statistics/api';

/**
 * A short, deterministic panel heading — nothing is stored server-side per
 * panel, so callers derive one from the spec instead of keeping a separate
 * label in sync with it. `t` is the caller's `useTranslation()` result, so
 * the label follows the active language like everything else.
 */
export function panelTitle(panel: DashboardPanelSpec, t: TFunction): string {
  const targets = Array.isArray(panel.target) ? panel.target : [panel.target];
  const targetLabel = targets
    .map((target) =>
      'user_id' in target
        ? t('statistics.target.you')
        : 'department_id' in target
          ? t('statistics.target.department', { name: target.department_id.slice(0, 8) })
          : t('statistics.target.company', { name: target.company_id.slice(0, 8) }),
    )
    .join(' vs. ');
  const typeLabel = t(`statistics.panelType.${panel.type}`);
  const metricsLabel =
    panel.metrics && panel.metrics.length > 0 ? ` · ${panel.metrics.join(', ')}` : '';
  return `${typeLabel}${metricsLabel} — ${targetLabel}`;
}
